<style>
  .all {
    /* TODO: MODAA KUN https://github.com/angular/material2/issues/8493 on korjattu */
    max-height: 95vh;
  }
</style>

@if (!hyvaksytty()) {
  <div class="all teksti-big" mat-dialog-content style="padding: 0 2vw">
    <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
    <div class="card" [class.big-card]="!cellphone()">
      <div style="text-align: center">
        <div class="otsikko-big light-blue-text">
          {{ 'muutoksia-palveluun.muutoksia-palveluun' | translate | async }}
        </div>
        <p>
          {{ 'muutoksia-palveluun.palvelupakettisi-tai-lisapalvelut-muuttuvat' | translate | async }}
        </p>
      </div>
      <div class="icon-legend-container">
        <div>
          <i class="fa fa-check green-text checkmark"></i>
          <span>{{ 'muutoksia-palveluun.otetaan-kayttoon' | translate | async }}</span>
        </div>
        <div>
          <i class="fa fa-times red-text checkmark" style="vertical-align: initial"></i>
          <span>{{ 'muutoksia-palveluun.lopetetaan' | translate | async }}</span>
        </div>
        <div>
          <i class="fa fa-check light-blue-text checkmark"></i>
          <span>{{ 'muutoksia-palveluun.ei-muutoksia' | translate | async }}</span>
        </div>
      </div>
      <div class="main-title">{{ 'lemonaid-sopimus-dialog.palvelupaketti' | translate | async }}</div>
      <div class="top-border bottom-border">
        <div class="left-margined-row">
          <div class="comparison-container">
            @if (vanhaPaketti()) {
              <div class="disabled-palvelu">
                <div>
                  <span style="font-weight: bold"><i class="fa fa-times red-text checkmark" style="vertical-align: initial"></i>{{ vanhaPaketti().nimi }}</span>
                </div>
                <ul>
                  @for (vanhaPalvelu of vanhaPaketti().palvelut; track vanhaPalvelu) {
                    <li class="palvelu-row" style="max-width: 260px">{{ vanhaPalvelu }}</li>
                  }
                </ul>
              </div>
            }
            @if (uusiPaketti()) {
              <div>
                <div>
                  @if (vanhaPaketti()) {
                    <i class="fa fa-check green-text checkmark"></i>
                  } @else {
                    <i class="fa fa-check light-blue-text checkmark"></i>
                  }
                  <span style="font-weight: bold">{{ uusiPaketti().nimi }}</span>
                </div>
                <ul>
                  @for (uusiPalvelu of uusiPaketti().palvelut; track uusiPalvelu) {
                    <li class="palvelu-row" style="max-width: 260px">{{ uusiPalvelu }}</li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>
      </div>
      @if (onLisapalveluita) {
        <div class="bottom-border" style="margin-top: 1em">
          <div class="left-margined-row">
            <div>{{ 'lemonaid-sopimus-dialog.lisapalvelut' | translate | async }}:</div>
            <div class="lisapalvelut-section">
              <div class="lisapalvelut-box">
                <div class="lisapalvelut-title">{{ 'lemonaid-sopimus-dialog.palkanlaskenta' | translate | async }}:</div>
                <div [class.disabled-palvelu]="!data.uusiVersio?.lisapalvelut?.PALKAT" class="palvelu-row">
                  @if (data.vanhaVersio?.lisapalvelut?.PALKAT && data.uusiVersio?.lisapalvelut?.PALKAT) {
                    <i class="fa fa-check light-blue-text checkmark"></i>
                  }
                  @if (!data.vanhaVersio?.lisapalvelut?.PALKAT && data.uusiVersio?.lisapalvelut?.PALKAT) {
                    <i class="fa fa-check green-text checkmark"></i>
                  }
                  @if (data.vanhaVersio?.lisapalvelut?.PALKAT && !data.uusiVersio?.lisapalvelut?.PALKAT) {
                    <i class="fa fa-times red-text checkmark" style="vertical-align: initial"></i>
                  }
                  @if (!data.vanhaVersio?.lisapalvelut?.PALKAT && !data.uusiVersio?.lisapalvelut?.PALKAT) {
                    <i class="checkmark" style="visibility: hidden"></i>
                  }
                  {{ 'lemonaid-sopimus-dialog.palkat-palvelu' | translate | async }}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="hinnat-section">
        <div>{{ 'muutoksia-palveluun.muutokset-astuvat-voimaan' | translate | async }} {{ data.uusiVersio.versioVoimassaAlkaen | lnumberpvm | async }}.</div>
        @if (nykyinenJaSeuraavaHintaObservable | async; as nykyinenJaSeuraavaHinta) {
          <div>
            @if (nykyinenJaSeuraavaHinta.seuraava) {
              <div>
                <div>{{ 'muutoksia-palveluun.kiintea-kuukausihinta-nyt' | translate | async }}: {{ nykyinenJaSeuraavaHinta.nykyinen?.hinta || 0 | currency: '€' }} +{{ 'muutoksia-palveluun.alv' | translate | async }}.</div>
                <div>{{ 'muutoksia-palveluun.kiintea-kuukausihinta-alkaen' | translate: { hintaPvm: nykyinenJaSeuraavaHinta.seuraava.voimassaAlkaen | lnumberpvm | async } | async }}: {{ nykyinenJaSeuraavaHinta.seuraava.hinta | currency: '€' }} +{{ 'muutoksia-palveluun.alv' | translate | async }}.</div>
              </div>
            } @else {
              <div>{{ 'muutoksia-palveluun.kiintea-kuukausihinta' | translate | async }}: {{ nykyinenJaSeuraavaHinta.nykyinen?.hinta || 0 | currency: '€' }} +{{ 'muutoksia-palveluun.alv' | translate | async }}.</div>
            }

            @if (muutJatkuvatVeloituksetObservable | async; as muutJatkuvatVeloitukset) {
              <div>
                @for (veloitus of muutJatkuvatVeloitukset; track veloitus) {
                  <div class="veloitus-row">
                    <div>{{ veloitus.nimi }}:</div>
                    <div>
                      {{ veloitus.hinta | currency: '€' }}<span class="veloitus-frekvenssi"> / {{ veloitus.frekvenssi }}</span>
                    </div>
                    @if (veloitus.tuleeVoimaan) {
                      <div class="veloitus-row-alkaen">{{ 'muutoksia-palveluun.alkaen' | translate | async }} {{ veloitus.tuleeVoimaan | lokaalipvm | async }}</div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="lataa-pdf-container">
      <button (click)="downloadSopimusPreview()" mat-button>
        <mat-icon class="mat-24">download</mat-icon>
        <span>{{ 'muutoksia-palveluun.toimeksiantosopimus' | translate | async }}</span>
      </button>
      @for (liitetyyppi of liitetyypit; track liitetyyppi) {
        <button (click)="downloadLiite(liitetyyppi)" mat-button>
          <mat-icon class="mat-24">download</mat-icon>
          <span>{{ liiteNimet[liitetyyppi] | translate | async }}</span>
        </button>
      }
    </div>
    <div class="button-container">
      <button class="secondarybutton" (click)="postpone()" mat-button>{{ 'muutoksia-palveluun.myohemmin' | translate | async }}</button>
      <button class="primarybutton" (click)="hyvaksyJaJatka()" mat-button>{{ 'muutoksia-palveluun.hyvaksy' | translate | async }}</button>
    </div>
  </div>
} @else {
  <div style="text-align: center">
    <div class="otsikko-small light-blue-text">
      {{ 'muutoksia-palveluun.palvelukokonaisuus-hyvaksytty' | translate | async }}
    </div>
    <p>{{ 'muutoksia-palveluun.uusi-palvelukokonaisuus-nyt-hyvaksytty' | translate | async }}</p>
  </div>
  <div class="button-container">
    <button (click)="sulje()" class="primarybutton" mat-button>{{ 'yleiset.jatka' | translate | async }}</button>
  </div>
}
